import React from "react";
import _ from "lodash";
import numeral from "numeral";
import {
  parseTableData,
  filterDataToGroup,
} from "../IntegrationVerificationHelper";
import GroupDataTable from "./GroupDataTable";
import FilterControl from "./FilterControl";

class BuildRequestView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      columns: [],
      groups: [],
      amount: null,

      filterGroups: [],
      filterRecords: [],
      filterAmount: null,

      tags: [],
      alias: [],
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const { records, columns, dataList, builds } = this.props;

    const [additionData] = dataList;
    const parsedCol = [...columns, "billing_key_tagged_request"];

    const keyMap = new Map();

    const idIndex = _.indexOf(additionData.columns, "ext_gam_unit_id");
    const dateIndex = _.indexOf(additionData.columns, "date");
    const targetIndex = _.indexOf(
      additionData.columns,
      "billing_key_tagged_request"
    );

    additionData.records.forEach((item) => {
      const id = item[idIndex];
      const date = item[dateIndex];
      keyMap.set(`${id}-${date}`, item[targetIndex] || 0);
    });

    const recIdIndex = _.indexOf(columns, "ext_gam_unit_id");
    const recDateIndex = _.indexOf(columns, "date");

    const newRecords = records.map((item) => {
      const id = item[recIdIndex];
      const date = item[recDateIndex];

      return [...item, keyMap.get(`${id}-${date}`) || 0];
    });

    const arrangeColumns = [
      {
        key: "ext_gam_unit_id",
        label: "Ext Gam Unit Id",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "date",
        label: "Date",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "build_id",
        label: "Build ID",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "request_v2",
        label: "build req #",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "billing_key_tagged_request",
        label: "bk req #",
        groupDatafunc: (dataList, key) => {
          const byExtId = _.groupBy(dataList, "ext_gam_unit_id");
          const resultByExtId = _.map(byExtId, (listByExtId) => {
            const byDate = _.groupBy(listByExtId, "date");
            const dateAverages = _.map(byDate, (listByDate) => {
              return _.meanBy(listByDate, key);
            });
            return _.sum(dateAverages);
          });

          return _.sum(resultByExtId);
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "coverage",
        label: "coverage %",
        parsefunc: ({ request_v2, billing_key_tagged_request }) => {
          return billing_key_tagged_request === 0
            ? 0
            : (request_v2 / billing_key_tagged_request) * 100;
        },
        format: (val) => {
          return `${numeral(val).format("0.00")}%`;
        },
      },
    ];

    const result = parseTableData({
      columns: parsedCol,
      arrangeColumns,
      records: newRecords,
      mainKey: "ext_gam_unit_id",
      subKey: "date",
      orderKey: "request_v2",
    });

    this.setState({
      ...result,
      filterGroups: result.groups,
      filterRecords: result.records,
      filterAmount: result.amount,
      columns: arrangeColumns,
      tags: [
        { value: "build_id", label: "Build ID", type: "string" },
        ...arrangeColumns
          .slice(3)
          .filter((item) => !item.hide)
          .map((item) => ({
            value: item.key,
            label: item.label,
          })),
      ],
      alias: [
        {
          func: (inputValue) => {
            return `build_id != "${inputValue}" AND coverage >= 20`;
          },
          label: "Filter Build Id",
          type: "select",
          options: _.map(builds, (item) => ({
            label: item.buildId,
            value: item.buildId,
          })),
        },
      ],
    });
  }

  handleSearch(expression) {
    const { records, columns } = this.state;

    const result = filterDataToGroup({
      expression,
      records,
      columns,
      hasSubGroup: true,
    });

    if (result) {
      this.setState({
        expression,
        ...result,
      });
    }
  }

  render() {
    const { columns, tags, filterAmount, filterGroups, filterRecords, alias } =
      this.state;

    return (
      <>
        <div className="mb-2">
          <FilterControl
            tags={tags}
            alias={alias}
            handleSearch={this.handleSearch}
          ></FilterControl>
        </div>

        <div className="w-full overflow-x-auto">
          <GroupDataTable
            records={filterRecords}
            groups={filterGroups}
            amount={filterAmount}
            mainKey="ext_gam_unit_id"
            subKey="date"
            columns={columns}
          ></GroupDataTable>
        </div>
      </>
    );
  }
}
export default BuildRequestView;
